import axios from "api/axios";

export const createUser = data => {
  return axios.post("admin/user", data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};
